// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1BWKJ","icon":"SortAdornment_icon__3eW0U","up":"SortAdornment_up__1h6Zs","down":"SortAdornment_down__1uUYc","active":"SortAdornment_active__3fIrh"};